/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Table_Overwrite_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to overwrite project: {error}" |
*
* @param {Explorer_Table_Overwrite_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_failed_toast = /** @type {((inputs: Explorer_Table_Overwrite_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'ecrasement du projet : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt konnte nicht überschrieben werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile sovrascrivere il progetto: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось перезаписать проект: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo sobrescribir el proyecto: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`覆盖项目失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの上書きに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट को ओवरराइट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao sobrescrever o projeto: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to overwrite project: ${i?.error}`)
});